module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r5r9r3r-7f978454905ab194a840095c8784198e.svg";